import React, { useEffect, useState } from 'react'
import { Popover } from 'antd'
import _ from 'lodash'
import endpoints from 'services/endpoints'
import axios from 'axios'
import { injectIntl } from 'react-intl'
import menuIconsSprite from 'assets/img/menu-icons/sprite.svg'
import HorizontalLoader from 'components/HorizontalLoader'
import Top from './Top'

import styles from './styles.module.scss'

const Diagnostics = ({ intl: { formatMessage }, collapsed }) => {
  const [last7Days, setLast7Days] = useState(0)
  const [last7DaysPosition, setLast7DaysPosition] = useState(0)

  const [last30Days, setLast30Days] = useState(0)
  const [last30DaysPosition, setLast30DaysPosition] = useState(0)

  const [total, setTotal] = useState(0)
  const [totalPosition, setTotalPosition] = useState(0)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    getDiagnosticsReport()
  }, [])

  const getDiagnosticsReport = () => {
    setLoading(true)

    axios
      .post(endpoints.getDiagnosticsReport)
      .then((res) => {
        setLoading(false)
        setLast7Days(_.get(res, 'data.diagnostic.last7Days.count', 0))
        setLast30Days(_.get(res, 'data.diagnostic.last30Days.count', 0))
        setTotal(_.get(res, 'data.diagnostic.total.count', 0))

        setLast7DaysPosition(_.get(res, 'data.diagnostic.last7Days.position', 0))
        setLast30DaysPosition(_.get(res, 'data.diagnostic.last7Days.position', 0))
        setTotalPosition(_.get(res, 'data.diagnostic.last7Days.position', 0))
      })
      .catch((err) => {
        setLoading(false)
        console.error(err)
      })
  }

  const renderDetails = () => (
    <div className={styles.details}>
      <div>
        <b>{last7Days}</b>&nbsp;{formatMessage({ id: 'menu.left.diagnostics.details.last7Days' })}
        <Top position={last7DaysPosition} showExactPosition />
      </div>
      <div>
        <b>{last30Days}</b>&nbsp;{formatMessage({ id: 'menu.left.diagnostics.details.last30Days' })}
        <Top position={last30DaysPosition} showExactPosition />
      </div>
      <div>
        <b>{total}</b>&nbsp;{formatMessage({ id: 'menu.left.diagnostics.details.total' })}
        <Top position={totalPosition} showExactPosition />
      </div>
    </div>
  )

  // Don't show details when it doesn't ready
  const popoverVisibilityProp = isLoading ? { visible: false } : {}

  return (
    <div className={styles.diagnostics}>
      <svg width={18} height={19} className={styles.icon}>
        <use href={`${menuIconsSprite}#diagnostics`} />
      </svg>
      <Popover
        className={{[styles.collapsed]: collapsed}}
        content={renderDetails()}
        title={null}
        {...popoverVisibilityProp}
      >
        <div className={styles.info}>
          <div className={styles.caption}>
            {formatMessage({ id: 'menu.left.diagnostics.title' })}
          </div>
          <div className={styles.value}>
            {isLoading ? (
              <HorizontalLoader />
            ) : (
              <div>
                <b>{last7Days}</b>&nbsp;
                {formatMessage({ id: 'menu.left.diagnostics.details.last7Days' })}
                <Top position={last7DaysPosition} />
              </div>
            )}
          </div>
        </div>
      </Popover>
    </div>
  )
}

export default injectIntl(Diagnostics)
